<template>
  <!-- 车辆型号 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <el-form-item :label="$t('pages.equipment.text5')">
          <el-select
            v-model="searchParams.belongCategoryId"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text22')">
          <el-input
            v-model="searchParams.bikeTypeName"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text23')">
          <el-input
            v-model="searchParams.bikeTypeCode"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton
          type="search"
          @click="search"
          v-permission="['equipmentMode:query']"
        ></DiluButton>
        <DiluButton
          type="reset"
          @click="reset"
          v-permission="['equipmentMode:reset']"
        ></DiluButton>
      </div>
    </div>

    <!-- 按钮区域 -->
    <div class="operation">
      <DiluButton
        type="add"
        @click="add"
        v-permission="['equipmentMode:add']"
      ></DiluButton>
      <DiluButton
        type="delete"
        @click="remove"
        v-permission="['equipmentMode:remove']"
        v-if="selectIds.length > 0"
      ></DiluButton>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
      @handleSelectionChange="handleSelectionChange"
      :total="total"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="date" label="#" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bikeCategoryName"
        :label="$t('pages.equipment.text5')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="bikeTypeName"
        :label="$t('pages.equipment.text22')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="bikeTypeCode"
        :label="$t('pages.equipment.text23')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="bikeTypeImagePath"
        :label="$t('pages.equipment.text24')"
        align="center"
      >
        <template slot-scope="scope">
          <el-image
            :src="scope.row.bikeTypeImagePath"
            class="elimg"
            style="width: 80px"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="bikeNum"
        :label="$t('pages.equipment.text25')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="protocolName"
        :label="$t('menu.protocol')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
        width="120px"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button
              @click="see(scope.row)"
              type="text"
              v-permission="['equipmentMode:see']"
              >{{ $t("button.look") }}</el-button
            >
            <el-button
              @click="edit(scope.row)"
              type="text"
              v-permission="['equipmentMode:edit']"
              >{{ $t("button.edit") }}</el-button
            >
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 新增弹窗 -->
    <EquipmentModeAdd
      @dialogClose="dialogClose"
      @equipmentModeList="equipmentModeList"
      :dialogVisible="dialogVisible"
      :options="options"
      :moduleState="moduleState"
      :currentEquipment="currentEquipment"
    />
  </div>
</template>


<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import EquipmentModeAdd from "./module/equipmentModeAdd.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      currentEquipment: null, //当前车辆型号
      moduleState: 0, // 弹窗状态 0 新增 1 修改 2 查看
      searchParams: {
        belongCategoryId: "", //车辆类别id
        bikeTypeCode: "", //型号代码
        bikeTypeName: "", //型号名称
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        belongCustomerId: "",
      },
      total: 0,
      selectIds: [],
      dialogVisible: false, //新增编辑弹窗
      options: [],
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      tableData: [],
      isSerch: false, //是否在查询
    };
  },
  components: {
    DiluTable,
    DiluButton,
    EquipmentModeAdd,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {
    this.bikeCategoryListAll();
    this.equipmentModeList();
  },
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.equipmentModeList();
    },
    //获取车辆型号列表
    equipmentModeList() {
      this.searchParams.belongCustomerId = this.platformData.id;
      this.request.equipmentModeList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
    //选中触发
    handleSelectionChange(e) {
      this.selectIds = e.map((item) => {
        return item.id;
      });
    },
    //关闭新增编辑弹窗
    dialogClose() {
      this.dialogVisible = false;
    },
    //重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams = {
        belongCategoryId: "", //车辆类别id
        bikeTypeCode: "", //型号代码
        bikeTypeName: "", //型号名称
        pageNum: 1, //页码
        pageSize: 10, //每页条数
        belongCustomerId: "",
      };
      this.total = 0;
      this.equipmentModeList();
    },
    //新增
    add() {
      this.currentEquipment = null;
      this.moduleState = 0;
      this.dialogVisible = true;
    },
    //查看
    see(e) {
      this.currentEquipment = e;
      this.moduleState = 2;
      this.dialogVisible = true;
    },
    //修改
    edit(e) {
      this.currentEquipment = e;
      this.moduleState = 1;
      this.dialogVisible = true;
    },
    //车辆类别-查询所有
    bikeCategoryListAll() {
      this.request.bikeCategoryListAll().then((res) => {
        this.options = res.data;
      });
    },

    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams = {
          belongCategoryId: "", //车辆类别id
          bikeTypeCode: "", //型号代码
          bikeTypeName: "", //型号名称
          pageNum: 1, //页码
          pageSize: 10, //每页条数
          belongCustomerId: "",
        };
      }
      this.searchParams.pageNum = e;
      this.equipmentModeList();
    },
    //删除
    remove() {
      this.$confirm(
        this.$t("pages.equipment.text26"),
        this.$t("public.text6"),
        {
          confirmButtonText: this.$t("button.determine"),
          cancelButtonText: this.$t("button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.request
            .equipmentModeDelete({
              ids: this.selectIds,
              appCode: this.platformData.appCode,
            })
            .then(() => {
              this.total = 0;
              this.searchParams.pageNum = 1;
              this.equipmentModeList();
              this.$message({
                type: "success",
                message: this.$t("public.text7"),
              });
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-slot i {
  font-size: 20px;
}
</style>